/**
 * enumeration
 */

// 项目状态枚举
const PRO_STATUS_ENUM = [
  { label: "禁用", value: 0 },
  { label: "启用", value: 1 },
  { label: "管理员禁用", value: 2 }
];

// 项目开放状态枚举（公有|私有）
const PRO_IS_PUBLIC_ENUM = [
  { label: "公有", value: 0 },
  { label: "私有", value: 1 }
];

// 项目是否置顶枚举（置顶|非置顶）
const PRO_IS_TOPPOING = [
  { label: "未置顶", value: 0 },
  { label: "置顶", value: 1 }
];

// 接口是否自定义（自定义|非自定义）
const SER_IS_CUSTOM = [
  { label: "非自定义", value: 0 },
  { label: "自定义", value: 1 }
];

// 担保物类型（自定义|非自定义）
const COLLATERAL_TYPE = [
  { label: "非自定义", value: 0 },
  { label: "自定义", value: 1 }
];

// 是否为必填项
const IS_MUST = [{ label: "是", value: 1 }, { label: "否", value: 0 }];

// 参数请求类型（headers | body | query）
const PARAM_REQ_TYPE = [
  { label: "headers", value: "headers" },
  { label: "query", value: "query" },
  { label: "body", value: "body" }
];

export default {
  methods: {
    // 项目类别（基础信息）
    async projectTypeEnum() {
      const result = await new Promise((resolve, reject) => {
        this.$request
          .enums_getProjectType()
          .then(res => {
            if (res.code === 0) {
              const list = res.data.map(item => ({
                key: item.id,
                value: `${item.name}(${item.value})`
              }));
              resolve(list);
            } else {
              reject([]);
            }
          })
          .catch(err => reject(err));
      });

      return result;
    },

    // 负载均衡（基础信息）
    async loadBalancerEnum() {
      const result = await new Promise((resolve, reject) => {
        this.$request
          .enums_getLoadBalancer()
          .then(res => {
            if (res.code === 0) {
              const list = res.data.map(item => ({
                key: item.id,
                value: item.name
              }));
              resolve(list);
            } else {
              reject([]);
            }
          })
          .catch(err => reject(err));
      });

      return result;
    },

    // 担保物类型
    async getCollateralTypeEnum() {
      const result = await new Promise((resolve, reject) => {
        this.$request
          .enums_getCollateralType()
          .then(res => {
            if (res.code === 0) {
              const list = Object.keys(res.enums).map(key => ({
                label: res.enums[key],
                value: key
              }));
              resolve(list);
            } else {
              reject([]);
            }
          })
          .catch(err => reject(err));
      });

      return result;
    },

    // 担保类型
    async getGuaranteeTypeEnum() {
      const result = await new Promise((resolve, reject) => {
        this.$request
          .enums_getGuaranteeType()
          .then(res => {
            if (res.code === 0) {
              const list = Object.keys(res.enums).map(key => ({
                label: res.enums[key],
                value: key
              }));
              resolve(list);
            } else {
              reject([]);
            }
          })
          .catch(err => reject(err));
      });

      return result;
    },

    // 参数请求类型（基础信息）（非接口）
    paramReqType() {
      return [...PARAM_REQ_TYPE];
    },

    // 项目状态（启用|禁用|管理员禁用）（非接口）
    projectStatusEnum() {
      return [...PRO_STATUS_ENUM];
    },

    // 项目开放状态枚举（公有|私有）（非接口）
    projectIsPublicEnum() {
      return [...PRO_IS_PUBLIC_ENUM];
    },

    // 项目是否置顶枚举（置顶|非置顶）（非接口）
    projectIsToppingEnum() {
      return [...PRO_IS_TOPPOING];
    },

    // 接口是否自定义（自定义|非自定义）（非接口）
    serviceIsCustomEnum() {
      return [...SER_IS_CUSTOM];
    },

    // 是否必填（是|否）（非接口）
    isMustEnum() {
      return [...IS_MUST];
    }
  }
};
